/**
 * Tutorial guidato dell'elenco Assistente AI.
 *
 * Un preparativo solo: la prima conversazione, che va aperta per raccontare la
 * timeline dei messaggi. `stopAssistantsTour` la richiude a fine giro, ma solo se
 * a spalancarla e' stato il tutorial: chi era gia' aperta prima resta com'era.
 */
const SCOPE = '[data-tour-scope="assistants-list"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let expandedRow = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre la conversazione della prima riga, se non c'e' gia' una riga aperta. */
function expandFirstRow() {
	if (visible(at('conversation'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		expandedRow = true;
		toggle.click();
	}
}

/** Richiude la conversazione aperta dal tutorial. */
function collapseRow() {
	if (!expandedRow) return;

	expandedRow = false;

	if (visible(at('conversation'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function stopAssistantsTour() {
	collapseRow();
}

export function createAssistantsTourSteps() {
	return [
		{
			body: "Qui finiscono le conversazioni dell'assistente virtuale del sito: ogni riga e' una chat completa fra un visitatore e l'assistente, non un singolo messaggio.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Assistente AI',
		},
		{
			body: "Sopra la tabella si filtra: la ricerca guarda il testo di tutti i messaggi (da tre caratteri, con Invio o la lente), Lingua tiene solo le chat in quelle lingue e la data restringe sull'ultimo messaggio - una data sola da li' in avanti, due per un periodo chiuso. Filtri e pagina restano nell'indirizzo: un refresh riparte uguale.",
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Trovare una conversazione',
		},
		{
			body: "La tabella mostra la data dell'ultimo messaggio, la prima domanda posta dal visitatore, la lingua in cui si e' svolta la chat e quanti messaggi sono stati scambiati in tutto.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "Il piu' a inizio riga apre la conversazione sotto la riga stessa. Premilo di nuovo per richiuderla: puoi tenerne aperte piu' di una alla volta.",
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			title: 'Aprire la conversazione',
		},
		{
			body: "La chat compare come sequenza di messaggi in ordine di tempo: si leggono di seguito la domanda del visitatore e la risposta dell'assistente, fino all'ultimo scambio.",
			before: expandFirstRow,
			key: 'conversation',
			placement: 'top',
			target: at('conversation'),
			timeout: 400,
			title: 'Il filo della conversazione',
		},
		{
			body: "Quando l'assistente ha consigliato dei prodotti, dentro il messaggio compare l'elenco con immagine, nome e marca: e' quello che il visitatore si e' visto proporre.",
			before: expandFirstRow,
			key: 'products',
			missing: 'skip',
			placement: 'top',
			target: at('products'),
			timeout: 400,
			title: 'I prodotti consigliati',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. L'ordinamento si cambia dall'intestazione Data e riguarda tutte le conversazioni, non solo quelle a schermo.",
			before: collapseRow,
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: 'Sfogliare le conversazioni',
		},
	];
}
